<template>
    <div class="print-page" v-if="data && user">
        <h2>0～6岁儿童心理行为发育初筛转诊单</h2>
        <br/>
        <h4 class="al-center">（第一联 乡镇卫生院或社区卫生服务中心留存）</h4>
        <br/>
        <div class="d-flex justify-center">
            <h3>编号</h3>
            <input class="squ ml-ns" type="text" readonly :value="it" v-for="it in user.serialNumber"/>
        </div>
        <br/>
        <br/>
        <div class="d-flex justify-center" style="width: 70%; margin: auto; font-size: 18px; font-weight: bold;">
            <span>儿童姓名</span>
            <p class="d-flex-item" style="flex: 2;"><input class="line" type="text" readonly :value="user.name"/></p>
            <span>性别</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$common.sex.find(e => e.value === user.sex).text"/></p>
            <span>出生日期</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('YYYY')"/></p>
            <span>年</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('MM')"/></p>
            <span>月</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('DD')"/></p>
            <span>日</span>
        </div>
        <br/>
        <table border>
            <tr>
                <td width="140">用户ID</td>
                <td colspan="3"><input class="line" type="text" readonly :value="user.hospitalId"/></td>
            </tr>            
            <tr>
                <td width="140">身份证号</td>
                <td colspan="3"><input class="line" type="text" readonly :value="user.idCard"/></td>
            </tr>
            <tr>
                <td>家长姓名</td>
                <td><input class="line" type="text" readonly :value="user.parents.length > 0 ? user.parents[0].name : ''"/></td>
                <td width="140">联系电话</td>
                <td><input class="line" type="text" readonly :value="user.parents.length > 0 ? user.parents[0].phone : ''"/></td>
            </tr>
            <tr>
                <th rowspan="4" class="al-left">转诊原因</th>
                <th colspan="3" class="al-left">预警征象筛查结果</th>
            </tr>
            <tr>
                <td colspan="3">
                    <span class="mask"/>
                    <ul>
                        <li>
                            <input type="checkbox" :checked="!data.warningSigns.find(e => e.value === 1) ? true : false"/> 未见异常
                        </li>
                        <li>
                            <input type="checkbox" :checked="data.warningSigns.find(e => e.value === 1) ? true : false"/> 异常，具体未通过项目
                            <p class="text" style="width: 100%;" v-if="data.warningSigns.find(e => e.value === 1)">
                                <span class="mr-xs" v-for="it in data.warningSigns" v-if="it.value === 1">{{ it.name }}</span>
                            </p>
                        </li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th colspan="3" class="al-left">语言功能及社会交往功能询问</th>
            </tr>
            <tr>
                <td colspan="3">
                    <span class="mask"/>
                    <ul>
                        <li><input type="checkbox" :checked="!data.langSocials.find(e => e.value === 1) ? true : false"/> 未见异常</li>
                        <li><input type="checkbox" :checked="data.langSocials[0].value === 1 ? true : false"/> {{ data.langSocials[0].name }}</li>
                        <li><input type="checkbox" :checked="data.langSocials[1].value === 1 ? true : false"/> {{ data.langSocials[1].name }}</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th colspan="4" class="al-left">儿童存在以上情况，建议转诊到 <input class="line" type="text" readonly style="display: inline-block; width: 45%;"/> 医疗机构进一步接受复筛</th>
            </tr>
            <tr>
                <th>医生签字</th>
                <td>
                    <input class="line" type="text" readonly/>
                </td>
                <th>填写日期</th>
                <td>
                    <div class="d-flex mt-xs">
                        <input class="d-flex-item line" type="text" readonly/>
                        <span>年</span>
                        <input class="d-flex-item line" type="text" readonly/>
                        <span>月</span>
                        <input class="d-flex-item line" type="text" readonly/>
                        <span>日</span>
                    </div>
                </td>
            </tr>
            <tr>
                <th>医疗机构</th>
                <td colspan="3">
                    <input class="line" type="text" readonly/>
                </td>
            </tr>
        </table>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            data: Object,
            user: Object,
        },
        data() {
            return {}
        },
        async beforeDestroy() {},
        async created() {
            console.log('初筛转诊单---------->', this.data, this.user);
        },
        async mounted() {},
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/prints/chushai_zhuanzhendan.vue